module.exports = __webpack_public_path__ + "static/media/Image05.170e9fae.png";